import { TbNumber1, TbNumber2, TbNumber3 } from "react-icons/tb";
import Banner from "./Banner";
import { useEffect, useState } from "react";
const Grievance = () => {
  const [htmlContent, setHtmlContent] = useState("");
    
      useEffect(() => {
        fetch("/PolicyPage/grievance.txt")
          .then((response) => response.text())
          .then((data) => setHtmlContent(data))
          .catch((error) => console.error("Error loading HTML file:", error));
      }, []);
  // const processes = [
  //   {
  //     description:
  //       "All the clients having complaint regarding any service or otherwise shall inform compliance department in writing. To mentioned mail at compliance@nexteraresearch.in .in or contact us +91 9891904233. To ensure timely recording and recognition of the grievance, the respective executive shall revert within 5 working days w.r.t redressal of such complaint.",
  //     icon: <TbNumber1 />,
  //     bgColor: "bg-gradient-to-r from-blue-500 to-indigo-600",
  //   },
  //   {
  //     description:
  //       "If the client still wants to escalate the complaint, he/she can approach at compliance@nexteraresearch.in. He being the highest authority at M/s NextEra Research can redress the complaint in the best possible manner. He shall reply the client within 15 working days.",
  //     icon: <TbNumber2 />,
  //     bgColor: "bg-gradient-to-r from-green-500 to-teal-600",
  //   },
  //   {
  //     description:
  //       "In case the client is still not satisfied he/she can escalate the matter with the regulators at www.sebi.gov.in. Please note that in case client marks a copy of mail to all the levels, it will not be considered as escalated matter, it shall in any case start from level 1 and only in case of a separate mail after expiration or reply from the previous level shall the complaint be considered at next level.",
  //     icon: <TbNumber3 />,
  //     bgColor: "bg-gradient-to-r from-purple-500 to-pink-600",
  //   },
  // ];

  return (
    // <section className="text-green-900 py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-white">
    //   <div className="max-w-6xl mx-auto">
    //     <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-green-900 mb-2">
    //       Grievance Redressal
    //     </h1>
    //     <div className="w-24 h-1 bg-green-700 mx-auto mb-10"></div>

    //     <p className="mt-6 text-lg md:text-xl font-medium text-green-800">
    //       Welcome to <strong className="font-bold">NextEra Research</strong>
    //     </p>

    //     <div className="bg-green-50 border-l-4 border-green-600 p-4 my-8">
    //       <p className="leading-relaxed text-base md:text-lg text-green-800">
    //         At NextEra Research, we strive to offer you seamless access to
    //         information, services, and a straightforward process for addressing any
    //         concerns. Our goal is to resolve your issues to your satisfaction with
    //         the first point of contact.
    //       </p>
    //     </div>

    //     <p className="mt-8 leading-relaxed text-base md:text-lg text-green-900 font-medium">
    //       Should our response not meet your expectations, please follow the formal escalation process outlined below:
    //     </p>

    //     <section className="w-full mt-12 space-y-8">
    //       {processes.map((process, i) => (
    //         <div
    //           key={i}
    //           className="relative flex items-center justify-center transition-all hover:shadow-lg"
    //         >
    //           <div className="bg-white w-full text-base md:text-lg md:max-w-6xl px-6 py-8 md:p-8 rounded-lg shadow-md border border-green-100 relative z-0 break-words">
    //             <div className="flex items-start">
    //               <div className={`flex-shrink-0 h-12 w-12 rounded-full ${process.bgColor} flex items-center justify-center text-white mr-4 mt-1`}>
    //                 <span className="text-2xl">
    //                   {process.icon}
    //                 </span>
    //               </div>
    //               <div>
    //                 <h3 className="text-lg md:text-xl font-semibold text-green-800 mb-2">
    //                   Step {i + 1}
    //                 </h3>
    //                 <p
    //                   className="leading-relaxed text-green-900"
    //                   dangerouslySetInnerHTML={{ __html: process.description }}
    //                 ></p>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       ))}
    //     </section>

    //     <div className="mt-16 bg-green-50 p-6 rounded-lg border border-green-200">
    //       <h3 className="text-xl font-semibold text-green-900 mb-4">
    //         Regulatory Escalation Channels
    //       </h3>

    //       <div className="space-y-6">
    //         <div>
    //           <p className="leading-relaxed text-base md:text-lg text-green-900">
    //             In case you are not satisfied with our response, you may lodge your grievance with SEBI at:
    //           </p>
    //           <a
    //             href="https://scores.sebi.gov.in/scores-home"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             className="text-green-700 hover:text-green-600 font-medium underline mt-2 inline-block"
    //           >
    //             https://scores.sebi.gov.in/scores-home
    //           </a>
    //           <p className="mt-2 text-sm text-green-700">
    //             (You may also write to any of the offices of SEBI)
    //           </p>
    //         </div>

    //         <div>
    //           <p className="leading-relaxed text-base md:text-lg text-green-900">
    //             SCORES may be accessed through the SCORES mobile application:
    //           </p>
    //           <a
    //             href="https://play.google.com/store/apps/details?id=com.ionicframework.sebi236330"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             className="text-green-700 hover:text-green-600 font-medium underline mt-2 inline-block"
    //           >
    //             Download SCORES App
    //           </a>
    //         </div>

    //         <div>
    //           <p className="leading-relaxed text-base md:text-lg text-green-900">
    //             ODR Portal could be accessed if unsatisfied with the response. Your
    //             attention is drawn to the SEBI circular on "Online Resolution of
    //             Disputes in the Indian Securities Market":
    //           </p>
    //           <a
    //             href="https://smartodr.in/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             className="text-green-700 hover:text-green-600 font-medium underline mt-2 inline-block"
    //           >
    //             https://smartodr.in/
    //           </a>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="mt-12 p-6 bg-white border border-green-300 rounded-lg">
    //       <h4 className="text-lg font-semibold text-green-900 mb-3">Important Note:</h4>
    //       <p className="text-sm md:text-base text-green-800 leading-relaxed">
    //         This grievance redressal mechanism is established in compliance with regulatory requirements. We encourage you to first attempt resolution through our internal channels before escalating to regulatory authorities.
    //       </p>
    //     </div>
    //   </div>
    //   <Banner/>
    // </section>
    <div className="py-12" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default Grievance;